import { render } from "./EnrolleeProviderSpouseOnboardComponent.vue?vue&type=template&id=0c3a5f15&scoped=true"
import script from "./EnrolleeProviderSpouseOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeProviderSpouseOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeProviderSpouseOnboardComponent.vue?vue&type=style&index=0&id=0c3a5f15&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3a5f15"]])

export default __exports__